var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_488_1204)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FC7BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.18925 12.0001V3.35109H9.59463V-5.3244H5.18925V-13.9999H0.783882V-5.3244H-3.62149V3.35109H0.783882V12.0001H5.18925ZM-3.62149 -5.3244V-9.66214H-8V-5.3244H-3.62149ZM14 -5.3244V-9.66214H9.59463V-5.3244H14ZM-3.62149 7.66238V3.35109H-8V7.66238H-3.62149ZM14 7.66238V3.35109H9.59463V7.66238H14Z",
    fill: "#020933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.1893 36.9999V28.3508H27.5946V19.6754H23.1893V10.9999H18.7839V19.6754H14.3785V28.3508H18.7839V36.9999H23.1893ZM14.3785 19.6754V15.3376H10V19.6754H14.3785ZM32 19.6754V15.3376H27.5946V19.6754H32ZM14.3785 32.6621V28.3508H10V32.6621H14.3785ZM32 32.6621V28.3508H27.5946V32.6621H32Z",
    fill: "#020933"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_488_1204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.df3d8eb72272e405402de08b7decec7a.svg";
export { ForwardRef as ReactComponent };